var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v("\n    "+_vm._s(_setup.fileSourceName)+" "),(_vm.showFullUri)?_c('span',[_vm._v("➡️ "+_vm._s(_setup.props.uri))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }